export const columnsCompany = [
  {
    title: '编号',
    dataIndex: 'id',
  },
  {
    title: '标题',
    dataIndex: 'name',
  },
  {
    title: '作者',
    dataIndex: 'admin_name',
  },
  {
    title: '视频',
    dataIndex: 'video',
    scopedSlots: { customRender: 'video' },
    width: 100,
  },
  {
    title: '更新时间',
    dataIndex: 'update_time',
  },
  {
    title: '发布时间',
    dataIndex: 'create_time',
  },
  {
    title: '视频详情',
    dataIndex: 'jump_url',
    scopedSlots: { customRender: 'jump_url' },
  },
  {
    title: '关联产品',
    dataIndex: 'product_info_title',
  },
  {
    title: '状态',
    dataIndex: 'status',
    scopedSlots: { customRender: 'status' },
  },
  {
    title: '操作',
    dataIndex: 'operation',
    scopedSlots: { customRender: 'operation' },
  },
];

export const columnsService = [
  {
    title: '编号',
    dataIndex: 'id',
  },
  {
    title: '标题',
    dataIndex: 'name',
  },
  {
    title: '作者',
    dataIndex: 'admin_name',
  },
  {
    title: '点击量',
    dataIndex: 'hits',
  },
  // {
  //   title: '点赞',
  //   dataIndex: 'likes',
  //   width: 100,
  // },
  // {
  //   title: '收藏',
  //   dataIndex: 'favorites',
  //   width: 100,
  // },
  {
    title: '视频',
    dataIndex: 'video',
    scopedSlots: { customRender: 'video' },
    width: 100,
  },
  {
    title: '更新时间',
    dataIndex: 'update_time',
  },
  {
    title: '发布时间',
    dataIndex: 'create_time',
  },
  {
    title: '关联产品',
    dataIndex: 'product_info_title',
  },
  {
    title: '状态',
    dataIndex: 'status',
    scopedSlots: { customRender: 'status' },
  },
  {
    title: '操作',
    dataIndex: 'operation',
    scopedSlots: { customRender: 'operation' },
  },
];
export const formDataCompany = [
  // {
  //   name: 'group_id',
  //   lable: '选择栏目',
  //   lableCol: 3,
  //   wrapperCol: 18,
  // },
  {
  	  name: 'product_id',
  	  lable: '关联产品',
  	 lableCol: 3,
  	 wrapperCol: 18,
   },
  {
    name: 'name',
    lable: '标题',
    lableCol: 3,
    wrapperCol: 18,
  },
  {
    name: 'post_excerpt',
    lable: '摘要',
    lableCol: 3,
    wrapperCol: 18,
  },
  {
    name: 'speaker',
    lable: '主讲人',
    lableCol: 3,
    wrapperCol: 18,
  },
  {
    name: 'video_id',
    lable: '上传视频',
    lableCol: 3,
    wrapperCol: 18,
  },
  {
    name: 'video_time',
    lable: '视频时长',
    lableCol: 3,
    wrapperCol: 18,
  },
  {
    name: 'post_content',
    lable: '内容',
    lableCol: 3,
    wrapperCol: 18,
  },
];

export const formDataService = [
  {
    name: 'company_id',
    lable: '选择企业',
    lableCol: 3,
    wrapperCol: 18,
  },
  // {
  //   name: 'group_id',
  //   lable: '选择栏目',
  //   lableCol: 3,
  //   wrapperCol: 18,
  // },
  {
  	  name: 'product_id',
  	  lable: '关联产品',
  	 lableCol: 3,
  	 wrapperCol: 18,
   },
  {
    name: 'name',
    lable: '标题',
    lableCol: 3,
    wrapperCol: 18,
  },
  {
    name: 'post_excerpt',
    lable: '摘要',
    lableCol: 3,
    wrapperCol: 18,
  },
  {
    name: 'speaker',
    lable: '主讲人',
    lableCol: 3,
    wrapperCol: 18,
  },
  {
    name: 'video_id',
    lable: '上传视频',
    lableCol: 3,
    wrapperCol: 18,
  },
  {
    name: 'video_time',
    lable: '视频时长',
    lableCol: 3,
    wrapperCol: 18,
  },
  {
    name: 'need_seconds',
    lable: '期望观看时长',
    lableCol: 3,
    wrapperCol: 18,
  },
  {
    name: 'post_content',
    lable: '内容',
    lableCol: 3,
    wrapperCol: 18,
  },
];